import { render, staticRenderFns } from "./singleResult.vue?vue&type=template&id=5e9873b3&scoped=true"
import script from "./singleResult.vue?vue&type=script&lang=js"
export * from "./singleResult.vue?vue&type=script&lang=js"
import style0 from "./singleResult.vue?vue&type=style&index=0&id=5e9873b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9873b3",
  null
  
)

export default component.exports